export const ONBOARDING_SESSION_ID_STORAGE_KEY = 'onboarding-session-id'

export const getStoredRegistrationSessionId = () => {
  try {
    return window.localStorage.getItem(ONBOARDING_SESSION_ID_STORAGE_KEY)
  } catch {
    return null
  }
}

export const storeRegistrationSessionId = (sessionId: string) => {
  try {
    window.localStorage.setItem(ONBOARDING_SESSION_ID_STORAGE_KEY, sessionId)
  } catch {
    return
  }
}

export const clearRegistrationSessionId = () => {
  try {
    window.localStorage.removeItem(ONBOARDING_SESSION_ID_STORAGE_KEY)
  } catch {
    return
  }
}
